module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 625 349",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }